import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
import styled from 'styled-components'
import { ModifyOpeningHours, ModifyOpeningHoursDialogContent, Subtitle } from 'pages/Home/styles'
import colors from 'globals/colors'
import { PencilIcon } from 'components/Icons'
import { useState } from 'react'
import Dialog from 'components/Dialog'
import { Input } from 'components'
import SubmitButton from 'components/SubmitButton'
import { Formik } from 'formik'
import { PARCEL_OPENING_HOURS_UPDATE } from 'pages/Home/mutations'
import { useMutation } from '@apollo/client'

const ParcelOpeningHoursUpdate = ({ currentCenters }) => {
  const { t } = useTranslation()

  const parcelOpeningHours = currentCenters[0].parcelOpeningHours

  const [showModifyParcelOpeningHours, setShowModifyParcelOpeningHours] = useState(false)
  const [parcelOpeningHoursUpdate] = useMutation(PARCEL_OPENING_HOURS_UPDATE)

  const placeholderExample = `${t('days.Monday')}: 09:00 - 17:00
${t('days.Tuesday')}: 09:00 - 17:00
${t('days.Wednesday')}: 09:00 - 17:00
${t('days.Thursday')}: 09:00 - 17:00
${t('days.Friday')}: 09:00 - 17:00`

  const onFinish = (values) => {
    parcelOpeningHoursUpdate({
      variables: {
        message: values.comment,
        addressId: currentCenters[0].id
      }
    }).then(() => {
      setShowModifyParcelOpeningHours(false)
    })
  }

  if (!parcelOpeningHours) {
    return null
  }

  return (
    <ParcelOpeningHoursWrapper>
      <Subtitle>{t('home.center.parcel-opening-hours')}</Subtitle>

      <ul>
        {parcelOpeningHours.map((hour) => (
          <li key={hour.id}>
            {t('days.' + hour.day)}: {dayjs(hour.openTime).utc().format('HH:mm')} -{' '}
            {dayjs(hour.closeTime).utc().format('HH:mm')}
          </li>
        ))}
      </ul>

      <ModifyOpeningHours onClick={() => setShowModifyParcelOpeningHours(true)}>
        {t('global.modify')}
        <PencilIcon />
      </ModifyOpeningHours>

      <Dialog visible={showModifyParcelOpeningHours} onClose={() => setShowModifyParcelOpeningHours(false)}>
        <ModifyOpeningHoursDialogContent>
          <b>{t('home.center.modify-parcel-opening-hours')}</b>
          <p>{t('home.center.modify-parcel-opening-hours-description-1')}</p>
          <p>{t('home.center.modify-parcel-opening-hours-description-2')}</p>
          <Formik
            initialValues={{
              comment: parcelOpeningHours
                .map(
                  (hour) =>
                    `${t('days.' + hour.day)}: ${dayjs(hour.openTime).utc().format('HH:mm')} - ${dayjs(hour.closeTime)
                      .utc()
                      .format('HH:mm')}`
                )
                .join('\n')
            }}
            onSubmit={onFinish}
          >
            {() => (
              <div>
                <Input name='comment' type='multiline' rows={7} placeholder={placeholderExample} />
                <p>{t('home.center.hours-updated-description')}</p>
                <SubmitButton text={t('global.send')} />
              </div>
            )}
          </Formik>
        </ModifyOpeningHoursDialogContent>
      </Dialog>
    </ParcelOpeningHoursWrapper>
  )
}

const ParcelOpeningHoursWrapper = styled.div`
  margin-top: 24px;

  & > ul {
    line-height: 22px;
    color: ${colors.steelGrey};
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
`

export default ParcelOpeningHoursUpdate
